import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import useReactRouter from 'use-react-router';
import { API_END_POINT } from '../../../api/api';
import { Store } from '../../../context/GlobalStore';
const AI_IMPORT_BLOCKING_STATUSES = [
    'queued',
    'scraping',
    'analyzing',
    'generating',
    'generatingImages',
    'saving',
    'failed',
];
const isAiImportBlockingStatus = (status) => Boolean(status && AI_IMPORT_BLOCKING_STATUSES.some((item) => item === status));
export const SiteV2AiImportRouteGuard = ({ children, }) => {
    var _a;
    const { match } = useReactRouter();
    const { workspaceUid, clientId, shopId, siteId } = match.params;
    const { globalState } = useContext(Store);
    const [isChecking, setIsChecking] = useState(true);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    useEffect(() => {
        var _a;
        if (!((_a = globalState.session) === null || _a === void 0 ? void 0 : _a.idToken)) {
            return;
        }
        let cancelled = false;
        setIsChecking(true);
        axios
            .get(`${API_END_POINT}/app/clients/${clientId}/shops/${shopId}/sites/${siteId}`, {
            headers: {
                Authorization: globalState.session.idToken,
            },
        })
            .then((response) => {
            var _a;
            if (cancelled) {
                return;
            }
            const site = response.data.site;
            setShouldRedirect(site.version === 'v2' &&
                isAiImportBlockingStatus((_a = site.aiImportJob) === null || _a === void 0 ? void 0 : _a.status));
        })
            .catch((error) => {
            if (!cancelled) {
                console.error(error);
            }
        })
            .finally(() => {
            if (!cancelled) {
                setIsChecking(false);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [clientId, (_a = globalState.session) === null || _a === void 0 ? void 0 : _a.idToken, shopId, siteId]);
    if (isChecking) {
        return _jsx(_Fragment, {});
    }
    if (shouldRedirect) {
        return (_jsx(Redirect, { to: `/a/${workspaceUid}/clients/${clientId}/shops/${shopId}/sites/v2/${siteId}/edit` }));
    }
    return _jsx(_Fragment, { children: children });
};
